import * as firebase from "firebase/app";
import { getFirestore } from "firebase/firestore";
import "firebase/auth";
import { GoogleAuthProvider } from "firebase/auth";

const provider = new GoogleAuthProvider();

const firebaseConfig = {
    apiKey: "AIzaSyDpkFg3QTEynSR2JG_8EIMtsypiGYh0HGA",
    authDomain: "msas-db.firebaseapp.com",
    projectId: "msas-db",
    storageBucket: "msas-db.appspot.com",
    messagingSenderId: "1080378762140",
    appId: "1:1080378762140:web:57cc0186e967a9e0ec5e59",
    measurementId: "G-QYWS6SJ9J1"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const db = getFirestore();

export {app, db, provider};